Myc21 = function() {
   var m_jCart = null;
   var VIEW_ENGINE = "/myc21.c21";
   var OVERVIEW_VIEW_ENGINE = "/myc21Overview.c21";
   var SV_LOGIN_DIALOG = "loginDialog";
   var SV_LOGIN_DIALOG_FACEBOOK = "loginDialogFacebook";
   var SV_LOGOUT = "logout";
   var SV_HIDE_PROPERTY = 'hideProperty';
   var SV_HIDE_AGENT = 'hideAgent';
   var SV_HIDE_OFFICE = 'hideOffice';
   var SV_UNHIDE_PROPERTY = 'unhideProperty';
   var SV_UNHIDE_AGENT = 'unhideAgent';
   var SV_UNHIDE_OFFICE = 'unhideOffice';
   var SV_CREATE_ACCOUNT_DIALOG = "createAccount";
   var SV_DELETE_ALL_SEARCHES = "deleteAllSearches";
   var SV_DELETE_SEARCH = "deleteSearch";
   var SV_EDIT_SEARCH_DIALOG = "editSearch";
   var SV_FORGOT_PASSWORD_DIALOG = "forgotPassword";
   var SV_SAVE_PROPERTY_NOTE = "savePropertyNote";
   var SV_ACCOUNT_SETTINGS = "accountSettings";
   var SV_SAVE_SEARCH_DIALOG = "saveSearch";
   var m_sFacebookAppId;
   var m_internationalization = window.internationalization;
   
   function loadMyC21Overview(page) {
	   portalAjax.doViewEngineAjax(
           'loadMyC21Overview',
           '/myc21Overview.c21',
           $.param({
              //submitted: 'true',
              p: page
           }),
           {
              cache: false,
              loadingIndicator : new LoadingIndicator(
                       $("#PageBody"))                  
           }
       );       	   
   }

   function hideProperty(sPropertyKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).addClass('hidden', 300, 'easeOutCirc');
         }
         ViewSession.addHiddenProperty(sPropertyKey);
         portalAjax.doViewEngineAjax(SV_HIDE_PROPERTY, VIEW_ENGINE, $.param({ id : sPropertyKey }));
      }
   }

   function unhideProperty(sPropertyKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).removeClass('hidden', 300, 'easeOutCirc');
         }
         ViewSession.removeHiddenProperty(sPropertyKey);
         portalAjax.doViewEngineAjax(SV_UNHIDE_PROPERTY, VIEW_ENGINE, $.param({ id : sPropertyKey }));
      }
   }

   function hideAgent(sAgentKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).addClass('hidden', 300, 'easeOutCirc');
         }
         ViewSession.addHiddenAgent(sAgentKey);
         portalAjax.doViewEngineAjax(SV_HIDE_AGENT, VIEW_ENGINE, $.param({ id : sAgentKey }));
      }
   }

   function unhideAgent(sAgentKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).removeClass('hidden', 300, 'easeOutCirc');
         } 
         ViewSession.removeHiddenAgent(sAgentKey);
         portalAjax.doViewEngineAjax(SV_UNHIDE_AGENT, VIEW_ENGINE, $.param({ id : sAgentKey }));
      }
   }

   function hideOffice(sOfficeKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).addClass('hidden', 300, 'easeOutCirc');
         }
         ViewSession.addHiddenOffice(sOfficeKey);
         portalAjax.doViewEngineAjax(SV_HIDE_OFFICE, VIEW_ENGINE, $.param({ id : sOfficeKey }));
      }
   }

   function unhideOffice(sOfficeKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).removeClass('hidden', 300, 'easeOutCirc');
         }
         ViewSession.removeHiddenOffice(sOfficeKey);
         portalAjax.doViewEngineAjax(SV_UNHIDE_OFFICE, VIEW_ENGINE, $.param({ id : sOfficeKey }));
      }
   }

   function favoriteProperty(sPropertyKey, sSelector, sPropertySourceID) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).addClass('favorite', 300, 'easeInCirc');
         }
         portalResults.trackListing(sPropertyKey, "Saved", sPropertySourceID);
         ViewSession.addFavoriteProperty(sPropertyKey);
         portalAjax.doViewEngineAjax('favoriteProperty', VIEW_ENGINE, $.param({id : sPropertyKey}));
      }
   }

   function unfavoriteProperty(sPropertyKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).removeClass('favorite', 300, 'easeInCirc');
         }
         ViewSession.removeFavoriteProperty(sPropertyKey);
         portalAjax.doViewEngineAjax('unfavoriteProperty', VIEW_ENGINE, $.param({id : sPropertyKey}));
      }
   }

   function favoriteMapProperty(sPropertyKey, sSelector, sPropertySourceID) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).addClass('favorite', 300, 'easeInCirc');            
         }
         $(".propertySummaryClickOverlay").addClass('favorite', 300, 'easeInCirc');
         portalResults.trackListing(sPropertyKey, "Saved", sPropertySourceID);
         ViewSession.addFavoriteProperty(sPropertyKey);
         portalAjax.doViewEngineAjax('favoriteProperty', VIEW_ENGINE, $.param({id : sPropertyKey}));
      }
   }
   function unfavoriteMapProperty(sPropertyKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).removeClass('favorite', 300, 'easeInCirc');
         }
         $(".propertySummaryClickOverlay").removeClass('favorite');
         ViewSession.removeFavoriteProperty(sPropertyKey);
         portalAjax.doViewEngineAjax('unfavoriteProperty', VIEW_ENGINE, $.param({id : sPropertyKey}));
      }
   }
   
   function favoriteAgent(sAgentKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).addClass('favorite', 300, 'easeOutCirc');
         }
         portalResults.trackAgent(sAgentKey, "Saved");
         ViewSession.addFavoriteAgent(sAgentKey);
         portalAjax.doViewEngineAjax('favoriteAgent', VIEW_ENGINE, $.param({ id : sAgentKey }));
      }
   }

   function unfavoriteAgent(sAgentKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).removeClass('favorite', 300, 'easeOutCirc');
         }
         ViewSession.removeFavoriteAgent(sAgentKey);
         portalAjax.doViewEngineAjax('unfavoriteAgent', VIEW_ENGINE, $ .param({ id : sAgentKey }));
      }
   }

   function favoriteOffice(sOfficeKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).addClass('favorite', 300, 'easeOutCirc');
         }
         portalResults.trackOffice(sOfficeKey, "Saved");
         ViewSession.addFavoriteOffice(sOfficeKey);
         portalAjax.doViewEngineAjax('favoriteOffice', VIEW_ENGINE, $.param({ id : sOfficeKey }));
      }
   }

   function unfavoriteOffice(sOfficeKey, sSelector) {
      if (checkCookies()) {
         if (sSelector) {
            $(sSelector).removeClass('favorite', 300, 'easeOutCirc');
         }
         ViewSession.removeFavoriteOffice(sOfficeKey);
         portalAjax.doViewEngineAjax('unfavoriteOffice', VIEW_ENGINE, $ .param({ id : sOfficeKey }));
      }
   }

   function changeCartCount(iCartCount, sNotification, sSearchName) {
      if (iCartCount > 0) {
         $("#hideMyC21").show();
      } else {
         $("#hideMyC21").hide();
      }
      if (sNotification) {
         if($('body').hasClass('res')) {
            var jButton = $(".header-account-button.c21-dropdown");
            if(sSearchName !== undefined) { //Saved search
               $("#HeaderLoggedIn").hide();
               $("#HeaderLoggedOff").hide();
               jButton.addClass('c21-dropdown-open').off('dropdown-close').on('dropdown-close', function() {
           		  $("#HeaderSearchSaved").hide();
                   $("#HeaderLoggedIn").show();
               }).find('> div').addClass('fadeInDown');
            	
               $("#HeaderSearchSaved .saved-search-name").html('"' + sSearchName + '"');
               $("#HeaderSearchSaved").show();
            	
               $("#HeaderSearchSaved").delay(3000).fadeOut( "slow", function() {
                  jButton.removeClass('c21-dropdown-open').find('> div').removeClass('fadeInDown');
                  $("#HeaderLoggedIn").show();
               });
            }
         } else {
            $.jGrowl(sNotification);
         }
      }
//    m_jCartCount.text(iCartCount);
//    if (iCartCount > 0) {
//       m_jCart.show();
//       var jEl = m_jCart.children().first();
//       jEl.effect("highlight", {
//          easing : 'easeInOutBack'
//       }, 1000, function() {
//          jEl.effect("highlight", {
//             easing : 'easeInOutBack'
//          }, 1000);
//       });
//    } else {
//       m_jCart.hide();
//    }
   }

   function logout() {
      if (checkCookies()) {
    	 var options = {cache:true};    	 
         portalAjax.doViewEngineAjax(SV_LOGOUT, VIEW_ENGINE, null, options);
      }
   }

   function deleteAllSavedSearches() {
      if (checkCookies()) {
         if (confirm("Are you sure you want to delete all of your saved searches?\n\nThis will permanently delete them.\n\nThis action cannot be undone.")) {
            portalAjax
                  .doViewEngineAjax(SV_DELETE_ALL_SEARCHES, VIEW_ENGINE);
         }
      }
   }

   var bCookiesEnabled = false;

   function checkCookies() {
      if (!bCookiesEnabled) {
         alert("This functionality requires you to enable cookies.");
         return false;
      }
      return true;
   }

   function initialize() {
      m_jCart = $('#topnavShoppingCart');
      portalAjax.bindLoadEvent($("body#myc21"), onPageLoad);
      $("#PageBody").on("portalAjaxLoadEvent", ImageLazyLoader.loadImages)
      var aCookies = document.cookie.split(";");
      for ( var i = 0; i < aCookies.length; i++) {
         var sCookie = aCookies[i].trim();
         if (sCookie.indexOf("c21.loc.visited") >= 0) {
            bCookiesEnabled = true;
         }
      }
   }

   function editSavedSearch(id) {
      if (checkCookies()) {
         editSearchForm.open(id);
      }
   }

   function deleteSavedSearch(id) {
      if (checkCookies()) {
         if (confirm("Are you sure you want to delete this saved search?\n\nThis will permanently delete it.\n\nThis action cannot be undone.")) {
            portalAjax.doViewEngineAjax(SV_DELETE_SEARCH, VIEW_ENGINE, $
                  .param({
                     id : id
                  }));
         }
      }
   }
   
   var saveSearchForm = PortalForm("#ss_loggedinWindow",
         SV_SAVE_SEARCH_DIALOG, VIEW_ENGINE);
   saveSearchForm.open = function(reloadform) {
      if (checkCookies()) {
         saveSearchForm.load({
        	 reloadForm: reloadform, 
             searchString : $.param(portalAjax.getParameters())
          });
      }
   }   
   saveSearchForm.success = function(reloadform) {
	   if(reloadform != null && reloadform == "true") {
	      new PortalParams().reload();   
	   }	   
   };
   saveSearchForm.cancelSave = function(reloadform) {
	   if(reloadform != null && reloadform == "true") {
	      new PortalParams().reload();   
	   }	   
	   modalWindows.closeWindow();
   };

   var loginForm = PortalForm("#signinWindow", SV_LOGIN_DIALOG, VIEW_ENGINE);
   loginForm.open = function(savethisSearch) {
      if (checkCookies()) {
    	 if(savethisSearch) {
             loginForm.load({
            	 savethissearch: savethisSearch,
                 searchString : $.param(portalAjax.getParameters())
              });
    	 } else {
    		 loginForm.load();
    	 } 
      }
   }
   loginForm.success = function(username, savethissearch) {	  
	  //alert(savethissearch); 
	  if(savethissearch != null && savethissearch.length > 0 && savethissearch == "true") {
		  saveSearchForm.open(true);  
	  } else {
	      new PortalParams().reload();
	  }
   };

   /**
    * Class to encapsulate facebook api for Cyber Javascript
    */
   var facebook = {};
   facebook.init = function() {
	  //Turn off facebook auth 
	  if(window.disableFacebookAuth == true) {
		  return;
	  } 	   
	   
      // Run only once ever
      if (facebook.initStarted !== undefined) return;
      facebook.initStarted = true;

      var jFbRoot = $('<div id="fb-root" />');
      $(document.body).prepend(jFbRoot);

      //Channel File:
      //The channel file addresses some issues with cross domain communication in certain browsers.
      //The channelUrl parameter is optional, but recommended.
      //Caching: When serving this file, you must send valid Expires headers with a long expiration period.
      //Without proper caching, cross domain communication will become very slow and users will suffer a severely degraded experience.
      var channelFile = window.location.hostname + '/facebook/channel.html';
      
      window.fbAsyncInit = function() {
         FB.init({
            appId : m_sFacebookAppId,
            status : true,
            cookie : true,
            channelUrl : channelFile, // Channel File
            xfbml : false
         });
      };
      
      // Load the SDK Asynchronously
	  var elScript = document.createElement('script');
      elScript.async = true;

      // We are including this locally because the Facebook Connect API
      // had a conflict with Bing/Virtual Earth that resulted in users not
      // being able to log in. The latest source code from GIT solved the
      // problem. See: http://forum.developers.facebook.net/viewtopic.php?id=81089
      elScript.src = document.location.protocol + "//connect.facebook.net/en_US/all.js";
      jFbRoot.append(elScript);
   }

   /**
    * This function is highly coupled to the myc21LoginPopup.jsp page
    */
   facebook.setupLoginTarget = function($clickTarget) {
	  //Turn off facebook auth 
	  if(window.disableFacebookAuth == true) {
		  return;
	  } 	   
 
      var bFacebookInAction = false;
      $clickTarget.on("click", function() {
         // If in the process of logging in
         if (bFacebookInAction === true) {
            // Don't continue
            return;
         }

         bFacebookInAction = true;
         FB.login(function(response) {
            if (response.authResponse) {
               if (response.scope) {
                  // user is logged in and granted some permissions.
                  // perms is a comma separated list of granted
                  // permissions

                  // FB.api("/me", function(response) {
                  // console.log(response);
                  // //ajax call
                  // });

               } else {
                  // user is logged in, but did not grant any permissions
               }
            	
               var authResponse = response.authResponse;
               var facebookAccessToken = authResponse.accessToken;
               var facebookId = authResponse.userID;                              
               myc21.loginUsingFacebook(facebookId, facebookAccessToken);
            } else {
               // user is not logged in
            }

            bFacebookInAction = false;
         }, {
            scope : 'offline_access,email,user_about_me,publish_stream'
         })
      });
   };

   var loginUsingFacebook = function(facebookId, facebookAccessToken) {
	  //Turn off facebook auth 
	  if(window.disableFacebookAuth == true) {
		  return;
	  }
	  
      if (checkCookies()) {
         portalAjax.doViewEngineAjax(SV_LOGIN_DIALOG_FACEBOOK, VIEW_ENGINE,
            $.param({
               facebookId : facebookId,
               facebookAccessToken : facebookAccessToken,
               submitted : "true"
            }));
      }
   };

   var createAccountForm = PortalForm("#createaccountWindow",
         SV_CREATE_ACCOUNT_DIALOG, VIEW_ENGINE);
   createAccountForm.open = function(savethisSearch) {
	  //alert(savethissearch); 
      if (checkCookies()) {
    	  if(savethisSearch) {
    		  createAccountForm.load({
             	  savethissearch: savethisSearch,
                  searchString : $.param(portalAjax.getParameters())
               });
     	 } else {
             createAccountForm.load();
     	 }
      }
   }
   createAccountForm.success = function(savethissearch) {	  
	  if(savethissearch != null && savethissearch.length > 0 && savethissearch == "true") {
		  saveSearchForm.open(true);  
	  } else {
	      new PortalParams().reload();
	  }
   };
	   
   var forgotPassword = PortalForm("#forgotloginWindow",
         SV_FORGOT_PASSWORD_DIALOG, VIEW_ENGINE);
   forgotPassword.open = function(savethisSearch) {
      if (checkCookies()) {
    	  if(savethisSearch) {
    		  forgotPassword.load({
    			  savethissearch: savethisSearch,
                  searchString : $.param(portalAjax.getParameters())
    		  });
    	  } else {
    		  forgotPassword.load();	  
    	  }         
      }
   }
   var accountSettingsForm = PageForm("#accountSettingsContainer", OVERVIEW_VIEW_ENGINE,
         SV_ACCOUNT_SETTINGS);
   accountSettingsForm.open = function() {
      if (checkCookies()) {
         forgotPassword.load();
      }
   }

   var editSearchForm = PortalForm("#ss_loggedinWindow",
         SV_EDIT_SEARCH_DIALOG, VIEW_ENGINE);
   editSearchForm.open = function(id) {
      if (checkCookies()) {
         editSearchForm.load({
            searchKey : id	  
         });
      }
   }
   function toggleLogInState() {
      $("#HeaderLoggedOff, #HeaderLoggedIn").toggle();
   }

   function setLoggedIn() {
      $("#HeaderLoggedOff").hide();
      $("#HeaderLoggedIn").show();
   }

   function savePropertyNote(sPropertyKey, sTextArea, sSelector, sPropertySourceId) {
      if (checkCookies()) {
         
         //Set the favorite icon
         if (sSelector) {
            $(sSelector).addClass('favorite', 300, 'easeInCirc');
         }
         portalResults.trackListing(sPropertyKey, "Saved", sPropertySourceId);
         ViewSession.addFavoriteProperty(sPropertyKey);

         portalAjax.doViewEngineAjax(SV_SAVE_PROPERTY_NOTE, VIEW_ENGINE, $
               .param({
                  id : sPropertyKey,
                  note : sTextArea ? $(sTextArea).val() : ''
               }));
      }
   }

   function resizeDisplay() {
      var jInnerContent = $('#innerContent'), jLeftRail = $('#leftRail'), jRightRail = $('#rightRail'), jColumnContainer = $('#columnContainer'), jContentArea = $('#contentArea');
      var iHeight = Math.max(500, jInnerContent.contentHeight() + 30);
      $('#mainPageFrame').height(iHeight + 144 - 154);
      jLeftRail.height(iHeight);
      jInnerContent.height(iHeight);
      jRightRail.height(iHeight);
      jColumnContainer.height(iHeight - 21);
      jContentArea.height(iHeight + 144);
   }

   function favoritesRemoveProperty(sPropertyKey) {
      if (checkCookies()) {
         portalAjax
               .doViewEngineAjax('unfavoriteProperty',
                     OVERVIEW_VIEW_ENGINE, $.param({
                        id : sPropertyKey
                     }), {
                        loadingIndicator : new LoadingIndicator(
                              $("#rightRail"))
                     });
      }
   }

   function favoritesRemoveAgent(sAgentKey) {
      if (checkCookies()) {
         portalAjax
               .doViewEngineAjax('unfavoriteAgent', OVERVIEW_VIEW_ENGINE,
                     $.param({
                        id : sAgentKey
                     }), {
                        loadingIndicator : new LoadingIndicator(
                              $("#rightRail"))
                     });
      }
   }

   function favoritesRemoveOffice(sOfficeKey) {
      if (checkCookies()) {
         portalAjax
               .doViewEngineAjax('unfavoriteOffice', OVERVIEW_VIEW_ENGINE,
                     $.param({
                        id : sOfficeKey
                     }), {
                        loadingIndicator : new LoadingIndicator(
                              $("#rightRail"))
                     });
      }
   }

   function startNotesEdit(sPropertyKey, eEl) {
      if (checkCookies()) {
         $("#itemNotes"+sPropertyKey).hide();
         $("#editNotes"+sPropertyKey).show();
         //resizeDisplay();
      }
   }

   function cancelNotesEdit(sPropertyKey, eEl) {
      if (checkCookies()) {
         $("#editNotes"+sPropertyKey).hide();
         $("#notes_"+sPropertyKey).val($("#originalNotes"+sPropertyKey).text());
         $("#itemNotes"+sPropertyKey).show();
      }
   }

   function updateNotesEdit(sPropertyKey, sTextArea) {
      if (checkCookies()) {
         var jTextArea = $(sTextArea);
         portalAjax
               .doViewEngineAjax('updatePropertyNote',
                     OVERVIEW_VIEW_ENGINE, $.param({
                        id : sPropertyKey,
                        note : jTextArea.val()
                     }), {
                        loadingIndicator : new LoadingIndicator(
                              $("#rightRail"))
                     });
      }
   }

   function deleteNotes(sPropertyKey) {
      if (checkCookies()) {
         if (confirm(m_internationalization.getString("Are you sure you want to clear the notes on this property?"))) {
            portalAjax.doViewEngineAjax('updatePropertyNote',
                  OVERVIEW_VIEW_ENGINE, $.param({
                     id : sPropertyKey,
                     note : ''
                  }), {
                     loadingIndicator : new LoadingIndicator(
                           $("#rightRail"))
                  });
         }
      }
   }

   function onPageLoad() {
      resizeDisplay();
   }

   function setFacebookAppId(sId) {
      m_sFacebookAppId = sId;
   }

   $(document).ready(function() {
      initialize()
   });

   return {
      VIEW_ENGINE : VIEW_ENGINE,
      SV_LOGIN_DIALOG : SV_LOGIN_DIALOG,
      checkCookies : checkCookies,
      saveSearchForm : saveSearchForm,
      editSearchForm : editSearchForm,
      accountSettingsForm : accountSettingsForm,
      resizeDisplay : resizeDisplay,
      deleteNotes : deleteNotes,
      startNotesEdit : startNotesEdit,
      updateNotesEdit : updateNotesEdit,
      cancelNotesEdit : cancelNotesEdit,
      logout : logout,
      savePropertyNote : savePropertyNote,
      toggleLogInState : toggleLogInState,
      setLoggedIn : setLoggedIn,
      loginForm : loginForm,
      setFacebookAppId : setFacebookAppId,
      facebook : facebook,
      loginUsingFacebook : loginUsingFacebook,
      forgotPassword : forgotPassword,
      deleteSavedSearch : deleteSavedSearch,
      editSavedSearch : editSavedSearch,
      createAccountForm : createAccountForm,
      deleteAllSavedSearches : deleteAllSavedSearches,
      hideProperty : hideProperty,
      unhideProperty : unhideProperty,
      hideAgent : hideAgent,
      unhideAgent : unhideAgent,
      hideOffice : hideOffice,
      unhideOffice : unhideOffice,
      favoriteProperty : favoriteProperty,
      unfavoriteProperty : unfavoriteProperty,
      favoriteMapProperty : favoriteMapProperty,
      unfavoriteMapProperty: unfavoriteMapProperty,
      favoriteAgent : favoriteAgent,
      unfavoriteAgent : unfavoriteAgent,
      favoriteOffice : favoriteOffice,
      unfavoriteOffice : unfavoriteOffice,
      changeCartCount : changeCartCount,
      favoritesRemoveProperty : favoritesRemoveProperty,
      favoritesRemoveAgent : favoritesRemoveAgent,
      favoritesRemoveOffice : favoritesRemoveOffice,
      loadMyC21Overview: loadMyC21Overview
   };
};
var myc21 = new Myc21();
